module.exports = __webpack_public_path__ + "static/about-img5-a6cccb5b8dfcd5da5d99b9d3b83a3991.png";